import { createGrid } from "ag-grid-enterprise";
// importa il css di ag-grid
import "ag-grid-enterprise/styles/ag-grid.css";
// Mi serve un tema che funzioni sullo scuro
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import { AG_GRID_LOCALE_IT } from "@ag-grid-community/locale";
import TreeResultsProvider from "./TreeResultsProvider";

import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

// Register all enterprise features
ModuleRegistry.registerModules([AllEnterpriseModule]);

export default class TreeViewer {
  constructor(target, targetDoc = null) {
    this.target = target;
    this.targetDoc = targetDoc;
  }

  init() {
    this.resultsProvider = new TreeResultsProvider();
    this.initGrid();
  }

  initGrid() {
    const gridOptions = {
      headerHeight: 0,

      columnDefs: this.getColumns(),
      rowModelType: "serverSide",
      serverSideDatasource: this.resultsProvider,
      localeText: AG_GRID_LOCALE_IT,
      suppressMenuHide: false,
      defaultColDef: {
        width: 240,
        flex: 1,
        sortable: false,
      },
      autoGroupColumnDef: {
        field: "label",
        cellRendererParams: {
          innerRenderer: (params) => {
            const span = document.createElement("span");
            span.className = "ag-value-wrap";

            if (params.data.mbc) {
              // span.innerText = "📁 " + params.data.label;
              span.innerHTML =
                ` 
                  <img src='/assets/site-icons/tree-icon-folder.svg' style='width: 18px;' /> 
                  <span>${params.data.label}</span>
                `; 

            } else {
              // span.innerText = "📄 " + params.data.label;
              span.innerHTML =
                ` 
                  <img src='/assets/site-icons/tree-icon-document.svg' style='width: 18px;' /> 
                  <span>${params.data.label}</span>
                `;
            }

            // Aggiungi evento click
            span.addEventListener("click", (event) => {
              event.stopPropagation(); // Evita che il click si propaghi e apra/chiuda i gruppi
              this.onLabelClick(params.data);
            });
            // aggiunge il title allo span
            span.title = params.data.label;

            return span;
          },
          tabIndex: 0,
        },
      },
      treeData: true,

      isServerSideGroup: (dataItem) => {
        // indicate if node is a group or a leaf
        return dataItem.mbc;
      },
      getServerSideGroupKey: (dataItem) => {
        // specify which group key to use
        return dataItem.id;
      },
      pagination: true, // Attiva la paginazione per evitare infinite scrolling
      paginationPageSize: 100000, // Definisci il numero di righe caricate per pagina
      cacheBlockSize: 100000, // Carica 100 righe per volta e non di più
      suppressPaginationPanel: true, // Disabilita il pannello di navigazione se non necessario
      maxBlocksInCache: 1, // Limita il numero di blocchi nella cache per prevenire caricamenti continui
      onCellKeyDown: (event) => {
        if (event.event.key === "Enter") {
          this.onLabelClick(event.data);
        }
      },
      onCellClicked: (event) => {
        this.onLabelClick(event.data);
      },
    };

    this.grid = createGrid(this.target.get(0), gridOptions);
  }

  getColumns() {
    let columnDefs = [];

    return columnDefs;
  }

  onLabelClick(data) {
    if (data.idDoc) {
      // E' un documento
      this.openDoc(data);
    }
  }

  openDoc(data) {
    console.log(data);
    // Apre il documento
    this.targetDoc.empty();
    // Legge il documento
    const pathCol = data.type.split("/");
    const col = pathCol[pathCol.length - 1];
    const path = "/solr/Detail/" + col + "/" + data.idDoc + "?popup=1";
    TreeViewer.ENUM++;
    $.ajax({
      url: path,
      type: "GET",
      success: this.onOpenDoc.bind(this, TreeViewer.ENUM),
      error: this.errorOnOpenDoc.bind(this),
    });
  }

  onOpenDoc(idCall, data) {
    if (idCall !== TreeViewer.ENUM) {
      return;
    }

    this.targetDoc.html(data);
    jQuery(".shown-by-tree").show();
    jQuery(".removed-by-tree").remove();

    this.setCssPropsToDoc();
  }

  errorOnOpenDoc() {
    this.targetDoc.html("<h1>Funzionalità non ancora disponibile</h1>");
    jQuery(".shown-by-tree").show();
    jQuery(".removed-by-tree").remove();
  }

  /**
   * sets offset variables to the container
   * to patch the sticky effect
   * */
  setCssPropsToDoc() {
    const sheet = document.querySelector(".sheet");
    const title = sheet?.querySelector(".sheet-header h1");
    const sectionTitle = sheet?.querySelector(".section-header h2");
    if (!title || !sectionTitle) return;

    sheet?.style.setProperty("--offset", `${sheet?.querySelector('.sheet-header')?.offsetHeight}px`);    
  }
}

TreeViewer.ENUM = 0;
